module.exports = __webpack_public_path__ + "static/media/ricky-ponting.635dfd35.jpg";